export default "__VITE_ASSET__b7aa2216__"